import type { ComponentType } from 'react'
import LoyaltyEsimBenefitsInfoModal from 'loyalty/components/LoyaltyEsimBenefitsInfoModal'
import { ESIM_INCLUSION_ID } from 'loyalty/constants/loyaltyEsimInclusion'

const LOYALTY_BENEFIT_INFO_MODALS: Record<string, ComponentType> = {
  [ESIM_INCLUSION_ID]: LoyaltyEsimBenefitsInfoModal,
}

/**
 * Returns the info modal component for a given inclusion ID, if one exists.
 * Add new loyalty benefit modals to the map above.
 */
export default function getLoyaltyBenefitInfoModal(inclusionId: string): ComponentType | undefined {
  return LOYALTY_BENEFIT_INFO_MODALS[inclusionId]
}
